import React, { useState } from 'react';
import { Box, Paper, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ReportsMenu from './components/ReportsMenu';
import RouteReport from './sections/RouteReport';
import RouteReplayReport from './sections/RouteReplayReport';

const ReportsLayout = ({ onClose, devices = [], positions = [] }) => {
  const [selectedSection, setSelectedSection] = useState('route');

  const sections = {
    route: {
      component: RouteReport,
      label: 'Ruta',
    },
    routeReplay: {
      component: RouteReplayReport,
      label: 'Repetición Ruta',
    },
  };

  const CurrentComponent =
    sections[selectedSection]?.component || RouteReport;

  return (
    <Box
      sx={{
        display: 'flex',
        height: '100%',
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 2000,
        bgcolor: '#f5f5f5',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: 280,
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 0,
          borderRight: '1px solid #e0e0e0',
          bgcolor: 'white',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 1.5,
            py: 1.5,
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ color: '#424242' }}
          >
            <ArrowBackIcon fontSize="small" />
          </IconButton>

          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              fontSize: '1.1rem',
              color: '#212121',
            }}
          >
            Reportes
          </Typography>
        </Box>

        <ReportsMenu
          selectedSection={selectedSection}
          onSectionChange={setSelectedSection}
        />
      </Paper>

      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          bgcolor: 'white',
        }}
      >
        <CurrentComponent
          devices={devices}
          positions={positions}
        />
      </Box>
    </Box>
  );
};

export default ReportsLayout;
